module.exports = __webpack_public_path__ + "static/10-formation-deformation-s-ix-0b8e5cd3b2c509ccbcf1a7691ae35fdd.jpg";